import React, {useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import UIDatePicker from "components/datepicker";
import CommonUtil from "../../../../utils/CommonUtil";
import StringUtil from "../../../../utils/StringUtil";
import codeDataStore from "../../../../common/codedata/store/CodeDataStore";
import UISelect from "../../../../components/selectbox/UISelect";
import UIUtils from "../../../../utils/UIUtils";
import UIUtil from "../../../../utils/UIUtils";
import UI from "../../../../components/UI";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";

function ContentsContainer() {
	const serverUrl = 'http://dev.fund.win-win.or.kr/';
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [handNoFMT, setHandNoFMT] = useState('');
	const [handAmt, setHandAmt] = useState('');
	const [oldHandAmt, setOldHandAmt] = useState('');
	const [handDate, setHandDate] = useState(new Date());
	const [donDate, setDonDate] = useState(new Date());
	const [notes, setNotes] = useState('');
	const [bizCd, setBizCd] = useState('');
	const [targetBizCd, setTargetBizCd] = useState('');
	const [oldBizCd, setOldBizCd] = useState('');
	const [bizNm1, setBizNm1] = useState('');
	const [bizNm2, setBizNm2] = useState('');
	const [donAmt, setDonAmt] = useState('');
	const [remainDonAmt, setRemainDonAmt] = useState('');
	const [judgeOtherList, setJudgeOtherList] = React.useState<any[]>([]);
	const [judgeDList, setJudgeDList] = React.useState<any[]>([]);
	const [judgeIList, setJudgeIList] = React.useState<any[]>([]);
	const [judgeUList, setJudgeUList] = React.useState<any[]>([]);
	const [handBizList, setHandBizList] = React.useState<any[]>([]);

	//밑에 담당자 정보
	const [corpNm,setCorpNm] = useState(''); //과제명
	const [bizNo,setBizNo] = useState(''); //사업자번호
	const [corpRegNo,setCorpRegNo] = useState(''); //사업자번호
	const [personNm,setPersonNm] = useState(''); //이름
	const [posiNm,setPosiNm] = useState(''); //직급
	const [deptNm,setDeptNm] = useState(''); //부서명
	const [emailAdres,setEmailAdres] = useState(''); //이메일
	const [ofcTelNo,setOfcTelNo] = useState(''); //전화번호

	/** 검색조건 */
	const [donNo,setDonNo] = useState('');
	const [handNo,setHandNo] = useState('');
	const [REC, setREC] = useState<any>({});

	const [handStsNm,setHandStsNm] = useState('');

	//파일정보 선언
	const [fileId, setFileId] = useState('');
	const [reqFileNm, setReqFileNm] = useState('');

	const [reqFiles] = useState(new TbComFile());
	const [otherFiles] = useState(new TbComFile());

	const [uploadComp, setUploadComp] = useState(false);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);

	//파일업로드
	const [uploadId, setUploadId] = React.useState("");

	//파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
		console.log("arrayNew ", JSON.stringify(arrayNew));

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
			FILE_STATUS:string;
		};

		//파일등록 정보
		arrayNew?.map((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					FILE_DETAIL_ID:item.uniqKey,
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/"),
					FILE_EXTSN:item.extension,
					FILE_GB:"",
					FILE_STATUS:"ADD"
				}
				fileInfos.push(fileInfo);
			}
			console.log("fileInfos : "+JSON.stringify(fileInfos));
		});

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_GB:"",
				FILE_STATUS:"DEL"
			}
			fileInfos.push(fileInfo);
		});

		setFileInfoList(fileInfos);
		setUploadComp(true);
    }

	async function onFileUpload()  {
		if(uploadId){
			await window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

	React.useEffect(() => {
		if(uploadComp) {
			saveAction(uploadComp);
		}
	},[uploadComp]);

	/**
   	 * 전용신청서
	*/
	const reqModal = () => {
		if(reqFileNm != '') {
			UIUtils.alert('파일 삭제 후 진행해주세요').then();
            return;
		}

		UIUtils.openFileUploadPopup({
			title: "전용신청공문",
			buttonTitle: "등록",
			attrs: {
				MaxTotalFileCount: "1",
				ExtensionAllowOrLimit: "1",
			},
			valueChanged: async data => {
				console.log("fileId uploadId : "+ uploadId);
				// @ts-ignore
				if(data != undefined && data.tbComFileMapngDetailList.length != 0){
					const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
					const arrayNew = dataArray.newFile;
					const arrayDel = dataArray.deleteFile;
					console.log("arrayNew", JSON.stringify(arrayNew));

					let fileInfos : {
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
						FILE_STATUS:string | undefined;
					}[] = [];

					let fileInfo : {
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
						FILE_STATUS:string | undefined;
					};

					// @ts-ignore
					let item = data.tbComFileMapngDetailList[0];

					// @ts-ignore
					let orginlFileNm = item.orginlFileNm;
					// @ts-ignore
					let streFileNm = item.streFileNm;
					// @ts-ignore
					let fileSize = item.fileSize;
					// @ts-ignore
					let strePath = item.strePath;
					// @ts-ignore
					let fileExtsn = item.fileExtsn;

					//파일등록 정보
					fileInfo = {
						ORGINL_FILE_NM:orginlFileNm,
						STRE_FILE_NM:streFileNm,
						FILE_SIZE:fileSize,
						STRE_PATH: strePath,
						FILE_EXTSN:fileExtsn,
						FILE_GB:'REQ',
						FILE_STATUS:"ADD"
					}

					// @ts-ignore
					setReqFileNm(orginlFileNm);

					fileInfos.push(fileInfo);
					let newList = [...fileInfoListPop];
					setFileInfoListPop(newList.concat(fileInfos));
				}
			}
		})
	}

	async function fileDelete(type){
		// @ts-ignore
		let item;
		if(type == 'REQ' && reqFiles.tbComFileMapngDetailList.length != 0){
			item = reqFiles.tbComFileMapngDetailList[0];
		}

		if(item == undefined){
			UIUtils.alert('삭제 할 파일이 없습니다.').then();
			return;
		}

		if(await UIUtils.confirm('삭제하시겠습니까?')){

			setReqFileNm('')

			let fileInfos : {
				FILE_DETAIL_ID:string | undefined;
				ORGINL_FILE_NM:string | undefined;
				STRE_FILE_NM:string | undefined;
				FILE_SIZE:number | undefined;
				STRE_PATH:string | undefined;
				FILE_EXTSN:string | undefined;
				FILE_GB:string | undefined;
				FILE_STATUS:string | undefined;
			}[] = [];

			let fileInfo : {
				FILE_DETAIL_ID:string | undefined;
				ORGINL_FILE_NM:string | undefined;
				STRE_FILE_NM:string | undefined;
				FILE_SIZE:number | undefined;
				STRE_PATH:string | undefined;
				FILE_EXTSN:string | undefined;
				FILE_GB:string | undefined;
				FILE_STATUS:string | undefined;
			};

			// @ts-ignore
			let uniqKey = item.fileDetailId;
			// @ts-ignore
			let orginlFileNm = item.orginlFileNm;
			// @ts-ignore
			let streFileNm = item.streFileNm;
			// @ts-ignore
			let fileSize = item.fileSize;
			// @ts-ignore
			let strePath = item.strePath;
			// @ts-ignore
			let fileExtsn = item.fileExtsn;

			//파일등록 정보
			fileInfo = {
				FILE_DETAIL_ID:uniqKey,
				ORGINL_FILE_NM:orginlFileNm,
				STRE_FILE_NM:streFileNm,
				FILE_SIZE:fileSize,
				STRE_PATH: strePath,
				FILE_EXTSN:fileExtsn,
				FILE_GB:type,
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);
			let newList = [...fileInfoListPop];
			setFileInfoListPop(newList.concat(fileInfos));
			UIUtils.alert('정상 처리 되었습니다 저장시 파일이 삭제 됩니다.').then();
		}
	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	function moveBack(){
		let dataToSend = {
			"vDON_NO": receivedData.vDON_NO,
			"vHAND_NO": receivedData.vHAND_NO
		};

		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './usr_2011',
			state: { data: dataToSend }
		});
	}

	async function initCall() {
		let param = {};
		param = {
			"HAND_NO": receivedData.vHAND_NO,
			"DON_NO": receivedData.vDON_NO
		};

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'usr_2011',
			data: param
		})
		const result = response;
		console.log(result);

		//handBizList.filter(a => a.BIZ_CD == '006')
		setHandBizList(result.REC4)

		setRemainDonAmt((Number(result.REMAIN_DON_AMT) + Number(result.REC[0].HAND_AMT))+'')
		setREC(result.REC[0]);
		setHandNo(result.REC[0].HAND_NO);
		setHandNoFMT(result.REC[0].HAND_NO);
		setHandStsNm(result.REC[0].HAND_STS_NM);
		setHandAmt(result.REC[0].HAND_AMT);
		setOldHandAmt(result.REC[0].HAND_AMT);
		setDonAmt(result.REC[0].DON_AMT);
		setOldBizCd(result.REC[0].BIZ_CD) //전용 타겟 biz_cd ( before )
		setBizCd(result.REC[0].DTL_BIZ_CD) //전용 대상 biz_cd ( after )
		setTargetBizCd(result.REC[0].BIZ_CD)
		setBizNm1(result.REC[0].BIZ_NM1)
		setBizNm2(result.REC[0].BIZ_NM2)
		setNotes(result.REC[0].NOTES)
		setHandDate(new Date(result.REC[0].HAND_DATE));
		setDonDate(new Date(Number(result.REC[0].DON_DATE2)));
		setFileId(result.REC[0].FILE_ID);

		setJudgeDList(result.REC2.filter(x => x.HAND_STS_CD == 'D'));
		setJudgeOtherList(result.REC2.filter(x => 'A,B,G'.indexOf(x.HAND_STS_CD) != -1 ));

		reqFiles.setTbComFileMapngDetailList([]);
		otherFiles.setTbComFileMapngDetailList([]);
		let fileList = result.FILE_INFO;
		if(fileList != null && fileList.length > 0) {
			for(let i=0; i<fileList.length; i++) {
				let fileGb = "";
				let fileInfo = fileList[i];
				if(fileInfo != null) {
					fileGb = fileInfo.FILE_GB;
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(fileInfo.DWLD_ID);
					fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
					fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
					fileDetail.setStrePath(fileInfo.STRE_PATH);
					fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
					fileDetail.setFileSize(fileInfo.FILE_SIZE);
					fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
					fileDetail.setRegistDt(fileInfo.REGIST_DT);

					if('REQ' == fileGb) {
						setReqFileNm(fileInfo.ORGINL_FILE_NM);
						reqFiles.putTbComFileMapngDetailList(fileDetail);
					}else {
						otherFiles.putTbComFileMapngDetailList(fileDetail);
					}
				}
			}
		}

		const response2:any = await CommonUtil.execute({
			url:'TbComPersonEntityMapper_select',
			data: param
		});

		const result2 = response2;
		console.log(result2)

		setCorpNm(result2.CORP_NM);
		setBizNo(result2.BIZ_NO);
		setCorpRegNo(result2.CORP_REG_NO);
		setPersonNm(result2.PERSON_NM);
		setPosiNm(result2.POSI_NM);
		setDeptNm(result2.DEPT_NM);
		setEmailAdres(result2.EMAIL_ADRES);
		setOfcTelNo(result2.OFC_TEL_NO);

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
	};

	const isChkValid = (chk) => {
		
		if(bizCd == ''){
			alertModal("[사업명]");
			return false;
		}
		
		if(Number(handAmt) == 0){
			alertModal("[전용금액]");
			return false;
		}
		
		saveAction(chk);
		return false;
	}

	const alertModal = async (chk) => {
		const value = await UIUtils.alert(<>
			<div className='ta-center'> 필수 입력이 완료되지 않았습니다.<br/>
			다시 확인 후 저장해 주세요.<br/>
			{(chk=="" || chk == null ? "" : chk)}
			</div>
		</>);
	}

	const saveAction = async (chk) => {
		if(reqFileNm == ''){
			await UIUtils.alert(<>
			<div className='ta-center'>* 필수서류가 누락되었습니다.<br/>
			파일첨부 후 제출해 주세요.<br/>
			[전용 신청서]</div>
			</>);
			return;
		}
		


		if(chk) {
			setUploadComp(false);
			
			let url = 'usr_2101_hando_chk';
			let param = {
				 "BIZ_CD": oldBizCd
				,"BIZ_NO": bizNo
			};

			//파라미터 전송
			const response:any = await CommonUtil.execute({
				url:url,
				data: param
			}).then((response: any) => {
				setRemainDonAmt(Number(response.REMAIN_DON_AMT) + Number(oldHandAmt)+ '');
				if(Number(handAmt) <= Number(response.REMAIN_DON_AMT)  + Number(oldHandAmt)){
					saveConfirm();
				}else{
					UIUtil.alert("전용가능금액이 변경되어 잔액이 부족합니다.").then()
				}

			}).catch((error) => {
				CommonUtil.showAxiosError(error);
				return;
			});

		}else {
			if(await UIUtils.confirm('수정 하시겠습니까?')) {
				onFileUpload();
			}
		}
	}
	
	async function saveConfirm(){
		//DON_CONT_DIV_CD -> type 기부내용코드 C현물 M금전

		let param = {
			"BIZ_NO": bizNo,
			"BIZ_CD": bizCd,
			"OLD_BIZ_CD": oldBizCd,
			"DON_NO": donNo,
			"HAND_NO": handNo,
			"HAND_AMT": handAmt,
			"PERSON_NM" : personNm,
			"POSI_NM" : posiNm,
			"DEPT_NM" : deptNm,
			"EMAIL_ADRES" : emailAdres,
			"OFC_TEL_NO" : ofcTelNo,
			"FILE_ID" : fileId,
			"FILE_INFO_LIST" : fileInfoListPop.concat(fileInfoList),
		};

		//바로 저장 진행
		const response:any = await CommonUtil.execute({
			url:'usr_2012',
			data: param
		})

		const result = response;
		console.log(result)

		//리스트 페이지로 이동
		let dataToSend = {};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './usr_2009',
			state: { data: dataToSend }
		});
	}

	React.useEffect(() => {
		codeDataStore.read(
			"cfms.portalBizCdList"
		).then(() => {
			console.log("cfms.portalBizCdList", codeDataStore.get("cfms.portalBizCdList"))
		});

		if(receivedData !== undefined) {
			setDonNo(receivedData.vDON_NO);
			initCall();
		}
	},[]);
	

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={1} lnbIdx={3}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">전용 내용 수정</h1>
					<section className="fund-section">
						<h3 className="section-title mb15">전용 요청 내용</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">처리 번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={handNoFMT} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">전용신청일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={dateToStr(handDate)} placeholder={''} readOnly={true} />  {/* [M.20240603] 수정 */}
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">출연 내용</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">출연사업</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizNm1} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">

								</div>
								<div className="fo-item">
									<p className="fo-key">출연금액</p>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items tf-unit">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(donAmt)) || ""} placeholder={''} readOnly={true}  />
												<span className="u">원</span>
											</div>
											<div className="tx-msg ml10"><span className="fc-pri">{StringUtil.isNotEmpty(Number(donAmt) + "")
														? '('+StringUtil.numKorPattern(Number(donAmt)) + " 원)"
														: ""}</span></div>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전용가능잔액(원)</p>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items tf-unit">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(remainDonAmt)) || ""} placeholder={''} readOnly={true}  />
												<span className="u">원</span>
											</div>
											<div className="tx-msg ml10"><span className="fc-pri">{StringUtil.isNotEmpty(Number(remainDonAmt) + "")
											? '('+StringUtil.numKorPattern(Number(remainDonAmt)) + " 원)"
											: ""}</span></div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<div className="hz-root hz-gap10 hz-item">
								<h3 className="section-title">전용 요청 금액</h3>
							</div>
						</div>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col />
										<col width="750px" />
									</colgroup>
									<thead>
										<tr>
											<th scope="col"><span className="th-req">사업명 선택</span></th>
											<th scope="col"><span className="th-req">전용금액(원)</span></th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<div className="sl sl-md w100p">
													<UISelect
														value={bizCd}
														valueChanged={(value) => {
																let fl1 = handBizList.filter(a => a.BIZ_CD == value && a.BIZ_CD != oldBizCd)

																if(fl1.length != 0) {
																	UIUtils.alert('동일한 사업으로 분배된 전용이 존재합니다.').then();
																	return
																}else if(targetBizCd == value) {
																	UIUtils.alert('출연사업과 동일한 사업은 선택할수없습니다.').then();
																	return
																}else {
																	setBizCd(String(value));
																}

															}
														}
														codeData={codeDataStore.get("cfms.portalBizCdList")}
														firstName={"sel"}
													/>
												</div>
											</td>
											<td>
												<div className="fund-form-group">
													<div className="fund-form-items tf-unit">
														<UIInput className={'tf tf-md ta-right'}
																 value={StringUtil.formatNumber(Number(handAmt)) || ""}
																 valueChanged={(value) => {
																	 let tmpVal = value.replace(/[^0-9]/g, "");
																	 if(Number(tmpVal) <= Number(remainDonAmt)) {
																		 setHandAmt(tmpVal)
																	 }else {
																		 UIUtils.alert('전용가능금액을 초과했습니다.').then();
																	 }
																	 
																 }}
																 placeholder={''}  />
														<span className="u">원</span>
													</div>
													<div className="tx-msg ml10"><span className="fc-pri">{StringUtil.isNotEmpty(Number(handAmt) + "")
														? '('+StringUtil.numKorPattern(Number(handAmt)) + " 원)"
														: ""}</span></div>
												</div>
											</td>

										</tr>
									</tbody>
								</table>
							</div>
						</form>
					</section>

					<section className="fund-section">
						<h3 className="section-title mb15">첨부파일</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3 req">
								<div className="fo-key">전용 신청서</div>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items mr30">
												<div className="hz-root hz-gap8 w100p">
													<UIInput className={'tf tf-md hz-item grow'} value={reqFileNm} placeholder={'파일을 첨부해 주세요.'} />
													<div className="hz-root hz-gap8 ">
														<Button color='pri-o2' size="md" onClick={reqModal}>찾기</Button>
														<Button color='gray-o' size="md" onClick={() => fileDelete('REQ')}>삭제</Button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<p className="tx-msg mt10 mb18"><span className="fc-pri">※ 자사별 전용공문을 첨부해 주세요.</span></p>
							<UI.FileUpload
								onCreationComplete={onCreationComplete}
								onUploadComplete={onUploadComplete}
								attrs={{
									MaxTotalFileCount: "1",
									ExtensionAllowOrLimit: "1",
									Width:"100%",
									ImgPreView: "1",
									Views: "thumbs"
								}}
								value={otherFiles}
							/>
						</form>
						<p className="tx-msg mb15"><span className="fc-pri">※ 항목 외 기타 파일들은 파일 첨부를 이용해 주세요.</span></p>
					</section>

					<section className="fund-section">
						<h3 className="section-title mb15">기업 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpRegNo} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(bizNo)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={personNm} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">직위</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={posiNm} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={deptNm} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={emailAdres} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.telephoneFormat(ofcTelNo)} placeholder={''} />
									</div>
								</div>
							</div>
						</form>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						<Button color="gray-o" size="md" onClick={() => moveBack()}>취소</Button>
						<Button color="pri" size="md" onClick={() => isChkValid(false)}>저장</Button>
						<Button color="gray-o" size="md" href="/main/usr_2000/usr_2009">목록</Button>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;